// removed by extract-text-webpack-plugin
module.exports = {"layout":"f6_am","button":"f6_bp","titlePrefix":"f6_f7"};


//////////////////
// WEBPACK FOOTER
// ./app/src/components/LoginPrompt/Banner/styles.module.css
// module id = 1126
// module chunks = 27